import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useAppTranslation } from "../TranslationContext";
import s from "./Login.module.css";


export const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState(''); // пока не используется в API, но оставим для интерфейса

  const handleSubmit = async (e) => {
    e.preventDefault(); // чтобы не перезагружалась страница

    try {
      const response = await fetch('https://api.rasulova-academy.uz/api/v1/dj-rest-auth/login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          username: username,
          email: email,
          password: password
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.message || 'Неверный логин или пароль');
        return;
      }

      const data = await response.json();
      const token = data.key;
      console.log(data)

      // Получаем данные пользователя
      const profileRes = await fetch('https://api.rasulova-academy.uz/api/v1/dj-rest-auth/user/', {
        headers: {
          'Authorization': 'Token ' + token
        }
      });

      const user = await profileRes.json();
      console.log(user)
      // Переименовываем pk → id
      const userWithId = { ...user, id: user.pk };
      delete userWithId.pk;
      console.log(userWithId)
      // Сохраняем
      login({ token, user: userWithId });
      localStorage.setItem('token', token);

      navigate('/dashboard');

    } catch (error) {
      alert('Сервер не отвечает. Попробуйте позже.');
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={s.wrapper}>
          <div className={s.loginBox}>
            <h2 className={s.loginBox__title}>{t('login')}</h2>

            {/* Inputs */}
            <div className={s.inputGroup}>
              {/* Username (не используется, но оставим визуально) */}
              <div className={s.inputWrapper}>
               <label className={s.label}>{t('Username')}</label>
                <input
                  type="text"
                  value={username}
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>

              {/* Email */}
              <div className={s.inputWrapper}>
                
                <label className={s.label}>{t('Email')}</label>
                <input
                  type="email"
                  value={email}
                  required
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Password */}
              <div className={s.inputWrapper}>
                <label className={s.label}>{t('Password')}</label>
                <input
                  type="password"
                  value={password}
                  required
                  placeholder=" "
                  className={s.input}
                  onChange={(e) => setPassword(e.target.value)}
                />
                
              </div>

              
            </div>

            {/* Forgot */}
            {/* <div className={s.forgotPassword}>
              <a href="#">I don't remember the password</a>
            </div> */}

            {/* Buttons */}
            <div className={s.buttonGroup}>
              <button type='submit' className={s.loginBtn}>{t('login')}</button>
              <Link to="/register" className={s.registerBtn}>{t('createProfile')}</Link>
            </div>

          </div>
        </div>
      </form>
    </>
  );
};
